"use client";

import {Button} from "@heroui/button";
import {Link} from "@heroui/link";

export default function Channel2Error({reset}: {reset: () => void}) {
    const isRumble = process.env.NEXT_PUBLIC_PLATFORM === "rumble";

    return (
        <article className="mx-auto flex min-h-80 w-full max-w-2xl flex-col items-center justify-center text-center">
            <nav aria-label="Breadcrumb" className="mb-8 self-start">
                <Link className="text-zinc-300" href={isRumble ? "/" : "/channels"} underline="hover">
                    {isRumble ? "Rumble Video Downloader" : "Channels"}
                </Link>
            </nav>
            <h1 className="text-3xl font-bold text-white">Could not load channel videos</h1>
            <p className="mt-3 text-zinc-400">
                The channel video service is currently unavailable. Please try again.
            </p>
            <Button className="mt-6" color="primary" onPress={reset}>
                Try again
            </Button>
        </article>
    );
}
